import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import StyleTwoSectionTitle from './StyleTwoSectionTitle'

export class StyleTwoSelfStudyCurriculum extends Component {
  static propTypes = {
    styleTwo: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    const { itemsData, ContentColor } = this.props;
    return (
      <div className="style-two-style-two-self-study-curriculum" style={{ background: `url(${itemsData.totalbackImg}) no-repeat` }}>
        <a name={itemsData.name}><StyleTwoSectionTitle isColorW={false} Data={itemsData} /></a>
        <table>
          <thead>
            <tr style={{ backgroundColor: `${ContentColor}` }}>
              <th className='width126'>课程序号</th>
              <th className='width126'>课程代码</th>
              <th className='width244'>课程名称</th>
              <th className='width124'>课程性质</th>
              <th className='width230'>实践环节对应理论课</th>
              <th className='width106'>考试标志</th>
              <th className='width94'>学分</th>
              <th className='width148'>备注</th>
            </tr>
          </thead>
          <tbody>
            {itemsData.list && itemsData.list.map(item => <tr key={item.id}>
              <td>{item.serial}</td>
              <td>{item.code}</td>
              <td>{item.name}</td>
              <td>{item.natrue}</td>
              <td>{item.correspond}</td>
              <td>{item.sign}</td>
              <td>{item.credit}</td>
              {item.remark && (item.rowspan ? <td style={{ padding: '0 15px', lineHeight: '24px', textAlign: 'left' }} rowspan={item.rowspan}>{item.remark}</td> : <td>{item.remark}</td> )}
            </tr>)}
          </tbody>
        </table>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    styleTwo: state.styleTwo,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleTwoSelfStudyCurriculum);



// WEBPACK FOOTER //
// ./src/features/style-two/StyleTwoSelfStudyCurriculum.js